(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-icon-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.__customIconWithTextInitialized) {
    window.__customIconWithTextInitialized = true;

    const SECTION_SELECTOR = '.custom-icon-with-text';
    const CARD_SELECTOR = '.custom-icon-with-text__card';
    const TRACK_SELECTOR = '[data-carousel-track]';
    const PREVIOUS_SELECTOR = '[data-carousel-prev]';
    const NEXT_SELECTOR = '[data-carousel-next]';
    const instances = new WeakMap();

    const debounce = (callback, wait = 120) => {
      let timer = null;

      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => callback(...args), wait);
      };
    };

    const equalizeCardHeights = (section) => {
      const cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
      if (!cards.length) return;

      cards.forEach((card) => {
        card.style.minHeight = '0px';
      });

      let maxHeight = 0;
      cards.forEach((card) => {
        maxHeight = Math.max(maxHeight, card.offsetHeight);
      });

      cards.forEach((card) => {
        card.style.minHeight = `${maxHeight}px`;
      });
    };

    const setupCarouselControls = (section) => {
      const track = section.querySelector(TRACK_SELECTOR);
      const previous = section.querySelector(PREVIOUS_SELECTOR);
      const next = section.querySelector(NEXT_SELECTOR);

      if (!(track instanceof HTMLElement)) return null;
      if (!(previous instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return null;
      if (!track.classList.contains('custom-icon-with-text__grid--mobile-carousel')) return null;

      const getScrollStep = () => {
        const firstItem = track.querySelector('.custom-icon-with-text__item');
        if (!(firstItem instanceof HTMLElement)) return track.clientWidth;

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateControlState = () => {
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScrollLeft - 1 || maxScrollLeft <= 0;
      };

      const scrollToPrevious = () => {
        track.scrollBy({ left: getScrollStep() * -1, behavior: 'smooth' });
      };

      const scrollToNext = () => {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      };

      const onScroll = debounce(updateControlState, 40);

      previous.addEventListener('click', scrollToPrevious);
      next.addEventListener('click', scrollToNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      updateControlState();

      return {
        update: updateControlState,
        destroy: () => {
          previous.removeEventListener('click', scrollToPrevious);
          next.removeEventListener('click', scrollToNext);
          track.removeEventListener('scroll', onScroll);
        },
      };
    };

    const setup = (section) => {
      if (!(section instanceof HTMLElement) || instances.has(section)) return;

      const onResize = debounce(() => equalizeCardHeights(section));
      const carouselControls = setupCarouselControls(section);
      const observer = new ResizeObserver(onResize);
      observer.observe(section);
      window.addEventListener('resize', onResize, { passive: true });
      if (carouselControls) {
        window.addEventListener('resize', carouselControls.update, { passive: true });
      }

      const images = section.querySelectorAll('.custom-icon-with-text__icon-image');
      images.forEach((image) => {
        if (!(image instanceof HTMLImageElement) || image.complete) return;
        image.addEventListener('load', onResize, { once: true });
        image.addEventListener('error', onResize, { once: true });
      });

      requestAnimationFrame(() => {
        equalizeCardHeights(section);
        if (carouselControls) carouselControls.update();
      });
      instances.set(section, { observer, onResize, carouselControls });
    };

    const teardown = (section) => {
      const instance = instances.get(section);
      if (!instance) return;

      instance.observer.disconnect();
      window.removeEventListener('resize', instance.onResize);
      if (instance.carouselControls) {
        window.removeEventListener('resize', instance.carouselControls.update);
        instance.carouselControls.destroy();
      }
      instances.delete(section);
    };

    const setupAll = (root = document) => {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => setup(section));
    };

    const teardownAll = (root) => {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => teardown(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupAll());
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      setupAll(target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      teardownAll(target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid-section"] && !Shopify.designMode) return;
  try {
    
  if (!window.__vgsInitialized) {
    window.__vgsInitialized = true;

    const SECTION_SELECTOR = '.vgs';
    const instances = new WeakMap();

    const setupNav = (section, track) => {
      const prevBtn = section.querySelector('.vgs__nav-btn--prev');
      const nextBtn = section.querySelector('.vgs__nav-btn--next');
      if (!prevBtn || !nextBtn) return null;

      const getStep = () => {
        const first = track.querySelector('.vgs__item');
        if (!first) return track.offsetWidth;
        const gap = parseFloat(getComputedStyle(track).gap) || 12;
        const perPage = Math.max(1, Math.round(track.offsetWidth / (first.offsetWidth + gap)));
        return (first.offsetWidth + gap) * perPage;
      };

      const sync = () => {
        prevBtn.disabled = track.scrollLeft < 2;
        nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      };

      const onPrev = () => track.scrollBy({ left: getStep() * -1, behavior: 'smooth' });
      const onNext = () => track.scrollBy({ left: getStep(), behavior: 'smooth' });

      prevBtn.addEventListener('click', onPrev);
      nextBtn.addEventListener('click', onNext);
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      return () => {
        prevBtn.removeEventListener('click', onPrev);
        nextBtn.removeEventListener('click', onNext);
        track.removeEventListener('scroll', sync);
        window.removeEventListener('resize', sync);
      };
    };

    const setup = (section) => {
      if (!(section instanceof HTMLElement) || instances.has(section)) return;

      const track = section.querySelector('.vgs__track');
      if (!track) return;

      const navCleanup = setupNav(section, track);
      if (navCleanup) instances.set(section, navCleanup);
    };

    const teardown = (section) => {
      const cleanup = instances.get(section);
      if (!cleanup) return;
      cleanup();
      instances.delete(section);
    };

    const setupAll = (root = document) => {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => setup(section));
    };

    const teardownAll = (root) => {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => teardown(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupAll());
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      setupAll(target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      teardownAll(target);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
